export default {
  页面曝光: {
    f_module: '页面曝光',
    f_resource: '云首发',
    f_type: 0
  },
  支付面板: {
    支付面板: {
      f_module: '支付面板',
      f_resource: '支付面板',
      f_type: 1
    },
    为自己购买: {
      f_module: '支付面板',
      f_resource: '为自己购买',
      f_type: 4
    },
    赠送好友: {
      f_module: '支付面板',
      f_resource: '赠送好友',
      f_type: 4
    },
    开通会员: {
      f_module: '支付面板',
      f_resource: '开通会员',
      f_type: 4
    },
    增加: {
      f_module: '支付面板',
      f_resource: '增加',
      f_type: 4
    },
    减少: {
      f_module: '支付面板',
      f_resource: '减少',
      f_type: 4
    },
    输入份数: {
      f_module: '支付面板',
      f_resource: '输入份数',
      f_type: 4
    },
    立即支付: {
      f_module: '支付面板',
      f_resource: '立即支付',
      f_type: 4
    },
    关闭: {
      f_module: '支付面板',
      f_resource: '关闭',
      f_type: 4
    }
  },
  开通弹框: {
    开通弹框: {
      f_module: '开通弹框',
      f_resource: '开通弹框',
      f_type: 1
    },
    原价购买: {
      f_module: '开通弹框',
      f_resource: '原价购买',
      f_type: 4
    },
    开通会员: {
      f_module: '开通弹框',
      f_resource: '开通会员',
      f_type: 4
    }
  },
  直播弹框: {
    直播弹框: {
      f_module: '直播弹框',
      f_resource: '直播弹框',
      f_type: 1
    },
    立即前往: {
      f_module: '直播弹框',
      f_resource: '立即前往',
      f_type: 4
    },
    关闭: {
      f_module: '直播弹框',
      f_resource: '关闭',
      f_type: 4
    }
  },
  秒杀模块: {
    秒杀模块: {
      f_module: '秒杀模块',
      f_resource: '秒杀模块',
      f_type: 1
    },
    立即抢票: {
      f_module: '秒杀模块',
      f_resource: '立即抢票',
      f_type: 4
    }
  },
  分享模块: {
    分享模块: {
      f_module: '分享模块',
      f_resource: '分享模块',
      f_type: 1
    },
    换图: {
      f_module: '分享模块',
      f_resource: '换图',
      f_type: 4
    },
    关闭: {
      f_module: '分享模块',
      f_resource: '关闭',
      f_type: 4
    }
  },
  购票模块: {
    购票模块: {
      f_module: '购票模块',
      f_resource: '购票模块',
      f_type: 1
    },
    晒票根: {
      f_module: '购票模块',
      f_resource: '晒票根',
      f_type: 4
    },
    购票: {
      f_module: '购票模块',
      f_resource: '购票',
      f_type: 4
    }
  },
  影片详情: {
    影片详情: {
      f_module: '影片详情',
      f_resource: '影片详情',
      f_type: 1
    },
    预约: {
      f_module: '影片详情',
      f_resource: '预约',
      f_type: 4
    },
    查看领取详情: {
      f_module: '影片详情',
      f_resource: '查看领取详情',
      f_type: 4
    },
    继续赠送: {
      f_module: '影片详情',
      f_resource: '继续赠送',
      f_type: 4
    },
    角色名: function _(name) {
      return {
        f_module: '影片详情',
        f_resource: "\u89D2\u8272\u540D".concat(name),
        f_type: 4
      };
    },
    角色视频: {
      f_module: '角色视频',
      f_resource: '角色视频',
      f_type: 1
    },
    角色头像: function _(name) {
      return {
        f_module: '角色视频',
        f_resource: "\u89D2\u8272\u5934\u50CF".concat(name),
        f_type: 4
      };
    },
    关闭演员弹窗: {
      f_module: '角色视频',
      f_resource: '关闭演员弹窗',
      f_type: 4
    },
    购票: {
      f_module: '角色视频',
      f_resource: '购票',
      f_type: 4
    }
  },
  领取弹框: {
    领取弹框: {
      f_module: '领取弹框',
      f_resource: '领取弹框',
      f_type: 1
    },
    立即领取: {
      f_module: '领取弹框',
      f_resource: '立即领取',
      f_type: 4
    },
    立即登录: {
      f_module: '领取弹框',
      f_resource: '立即登录',
      f_type: 4
    },
    自己领取: {
      f_module: '领取弹框',
      f_resource: '自己领取',
      f_type: 4
    },
    关闭: {
      f_module: '领取弹框',
      f_resource: '关闭',
      f_type: 4
    }
  },
  领取列表弹框: {
    领取列表弹框: {
      f_module: '领取列表弹框',
      f_resource: '领取列表弹框',
      f_type: 1
    },
    我知道了: {
      f_module: '领取列表弹框',
      f_resource: '我知道了',
      f_type: 4
    }
  },
  头图: {
    头图: {
      f_module: '头图',
      f_resource: '头图',
      f_type: 1
    },
    头像: {
      f_module: '头图',
      f_resource: '头像',
      f_type: 4
    },
    播放: function _(txt) {
      return {
        f_module: '头图',
        f_resource: "\u64AD\u653E".concat(txt),
        f_type: 4
      };
    },
    右下方按钮: function _(txt) {
      return {
        f_module: '头图',
        f_resource: "\u53F3\u4E0B\u65B9\u6309\u94AE".concat(txt),
        f_type: 4
      };
    },
    活动规则: {
      f_module: '头图',
      f_resource: '活动规则',
      f_type: 4
    },
    高清点播: {
      f_module: '头图',
      f_resource: '高清点播',
      f_type: 4
    },
    导航: {
      f_module: '头图',
      f_resource: '导航',
      f_type: 4
    }
  },
  tab锚点: {
    tab锚点: {
      f_module: 'tab锚点',
      f_resource: 'tab锚点',
      f_type: 1
    },
    影片详情: {
      f_module: 'tab锚点',
      f_resource: '影片详情',
      f_type: 4
    },
    云首发特权: {
      f_module: 'tab锚点',
      f_resource: '云首发特权',
      f_type: 4
    },
    大咖推荐: {
      f_module: 'tab锚点',
      f_resource: '大咖推荐',
      f_type: 4
    },
    云首发详情: {
      f_module: 'tab锚点',
      f_resource: '云首发详情',
      f_type: 4
    }
  },
  云首发特权: {
    礼包模块: {
      f_module: '礼包模块',
      f_resource: '礼包模块',
      f_type: 1
    },
    礼包规则: {
      f_module: '礼包模块',
      f_resource: '礼包规则',
      f_type: 4
    },
    礼包资产: {
      f_module: '礼包模块',
      f_resource: '礼包资产',
      f_type: 4
    },
    礼包项目: function _(name) {
      return {
        f_module: '礼包模块',
        f_resource: name,
        f_type: 4
      };
    },
    抓娃娃: {
      f_module: '礼包模块',
      f_resource: '抓娃娃',
      f_type: 4
    },
    抓娃娃资产: {
      f_module: '礼包模块',
      f_resource: '抓娃娃资产',
      f_type: 4
    },
    道具玩法: {
      f_module: '道具玩法',
      f_resource: '道具玩法',
      f_type: 1
    },
    发电: {
      f_module: '道具玩法',
      f_resource: '发电',
      f_type: 4
    },
    立即购票: {
      f_module: '道具玩法',
      f_resource: '立即购票',
      f_type: 4
    },
    免费活动: {
      f_module: '免费活动',
      f_resource: '免费活动',
      f_type: 1
    },
    免费活动项目: function _(name) {
      return {
        f_module: '免费活动',
        f_resource: "\u514D\u8D39\u6D3B\u52A8".concat(name),
        f_type: 4
      };
    },
    视听权益: {
      f_module: '视听权益',
      f_resource: '视听权益',
      f_type: 1
    },
    视听权益项目: function _(name) {
      return {
        f_module: '视听权益',
        f_resource: "".concat(name),
        f_type: 4
      };
    }
  },
  云首发介绍: {
    云首发介绍: {
      f_module: '云首发介绍',
      f_resource: '云首发介绍',
      f_type: 1
    },
    更多精彩: function _(name) {
      return {
        f_module: '云首发介绍',
        f_resource: "\u66F4\u591A\u7CBE\u5F69".concat(name),
        f_type: 4
      };
    }
  }
};